import { useAtom } from '@reatom/npm-react'
import { match } from 'ts-pattern'

import { isAdminAtom } from '@root/entities/auth'

import { supportDialogScreenAtom } from '../atoms'

import { SupportConversation } from './support-conversation'
import { SupportCreateTicket } from './support-create'
import { SupportTickets } from './support-tickets'
import { SupportTicketsAdmin } from './support-tickets-admin'

type SupportScreenProps = {
  onOpenChange?: (open: boolean) => void
}

export const SupportScreen: React.FC<SupportScreenProps> = ({
  onOpenChange,
}) => {
  const [screen, setScreen] = useAtom(supportDialogScreenAtom)
  const [isAdmin] = useAtom(isAdminAtom)

  const handleClose = onOpenChange ? () => onOpenChange(false) : undefined

  if (isAdmin) {
    return match(screen)
      .with({ screen: 'conversation' }, ({ ticket }) => (
        <SupportConversation ticket={ticket} onClose={handleClose} />
      ))
      .with({ screen: 'tickets' }, () => (
        <SupportTicketsAdmin onClose={handleClose} />
      ))
      .otherwise(() => undefined)
  }

  return match(screen)
    .with({ screen: 'create' }, () => (
      <SupportCreateTicket
        onDone={() => setScreen({ screen: 'tickets' })}
        onClose={handleClose}
      />
    ))
    .with({ screen: 'conversation' }, ({ ticket }) => (
      <SupportConversation ticket={ticket} onClose={handleClose} />
    ))
    .with({ screen: 'tickets' }, () => <SupportTickets onClose={handleClose} />)
    .otherwise(() => undefined)
}
